'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { RadioGroup } from '@headlessui/react'

import { updateSearchParams, getSearchParams, removeSearchParam } from "@utils";
// import { roomTypes } from '@constants';


const RoomFilter = ({ title, roomTypes, lang, dictionary }) => {
    const router = useRouter();
    let [room, setRoom] = useState(roomTypes[lang][0])
    let [addChecked, setAddChecked] = useState(roomTypes[lang][0].value)


    const handleUpdateParams = (e) => {
        let newPathName
        if (e.value == 0) {
            newPathName = removeSearchParam(title);
        } else {
            newPathName = updateSearchParams(title, e.value);
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        const roomValue = getSearchParams('room')
        setAddChecked(roomValue)
        const newValue = roomTypes[lang].find(obj => obj.value === addChecked);

        if (newValue != undefined) {
            setRoom(newValue)
        } else {
            setRoom(roomTypes[lang][0])
        }

    }, [handleUpdateParams])

    return (
        <div className="w-full">
            <span className='text-sm text-secondary'>{dictionary.filter.numberOfRooms}:</span>
            <div className="w-full">
                <RadioGroup value={room} onChange={(value) => {
                    setRoom(value)
                    handleUpdateParams(value)
                }}
                    className='w-full py-1 mt-1 flex flex-row'
                >
                    {roomTypes[lang].map((roomType) => (
                        <RadioGroup.Option
                            key={roomType.value}
                            value={roomType}
                            checked={roomType === room}
                            className={({ active, checked }) =>
                                `${active
                                    ? ''
                                    : ''
                                }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                                }
                                    w-full relative flex cursor-pointer round-style px-2 py-2 shadow-md focus:outline-none`
                            }
                        >
                            {({ active, checked }) => (
                                <>
                                    <div className="flex w-full items-center justify-between">
                                        <div className="flex items-center">
                                            <div className="text-sm text-center">
                                                <RadioGroup.Label
                                                    as="p"
                                                    className={`font-medium w-full  ${checked ? 'text-light' : 'text-maincolor'
                                                        }`}
                                                >
                                                    {roomType.title}
                                                </RadioGroup.Label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </RadioGroup.Option>
                    ))}
                </RadioGroup>
            </div>
        </div>
    )
}

export default RoomFilter